var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUndoneIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4167 0H3.63906C3.44249 0 3.25932 0.094453 3.15082 0.251119L0.0953799 4.69556C-0.0317933 4.88056 -0.0317933 5.11944 0.0953799 5.30444L3.15082 9.74888C3.25932 9.90555 3.44249 10 3.63906 10H13.4167C13.7393 10 14 9.75167 14 9.44445V0.555571C14 0.248333 13.7393 0 13.4167 0ZM10.9125 7.61498C10.7987 7.72331 10.6494 7.77777 10.5001 7.77777C10.3507 7.77777 10.2014 7.72331 10.0877 7.61498L8.16677 5.78553L6.24588 7.61498C6.13213 7.72331 5.98281 7.77777 5.83346 7.77777C5.68414 7.77777 5.53479 7.72331 5.42104 7.61498C5.19297 7.39777 5.19297 7.04665 5.42104 6.82944L7.34193 4.99999L5.42104 3.17054C5.19297 2.95333 5.19297 2.60221 5.42104 2.38499C5.64911 2.16778 6.01778 2.16778 6.24585 2.38499L8.16674 4.21444L10.0876 2.38499C10.3157 2.16778 10.6844 2.16778 10.9124 2.38499C11.1405 2.60221 11.1405 2.95333 10.9124 3.17054L8.99155 4.99999L10.9125 6.82944C11.1406 7.04665 11.1406 7.39777 10.9125 7.61498Z",
    fill: "#000000"
  })));
}

export default SvgUndoneIcon;